import { StaticImageData } from "next/legacy/image";
import solution_1 from "/public/images/landing/solution/1.png";
import solution_2 from "/public/images/landing/solution/2.png";
import solution_3 from "/public/images/landing/solution/3.png";
import solution_4 from "/public/images/landing/solution/4.png";
import solution_5 from "/public/images/landing/solution/5.png";
import mkt_solution_1 from "/public/images/landing/solution/mkt_1.png";

export interface SolutionData {
  number: number;
  title: string;
  img: StaticImageData;
  desc: string;
}

export const PMSolutionTitle = () => {
  return (
    <>
      현업의 사이클을 압축한
      <br />
      커리큘럼으로 빠르게 성장합니다.
    </>
  );
};

export const pmLandingSolutionData = [
  {
    number: 1,
    title: "내 손으로 실제 프로덕트 기획",
    img: solution_1,
    desc: "기존의 프로덕트를 역기획하는 모의 프로젝트가 아닙니다. 현업 멘토의 과제 피드백을 받으며 실제 PM이 일하는 방식대로 새로운 프로덕트를 기획합니다.",
  },
  {
    number: 2,
    title: "직접 해보며 익히는 서비스 개발 이해",
    img: solution_2,
    desc: "왕초보도 할 수 있는 스파르타코딩클럽 개발 교육을 꼭 필요한 만큼만 직접 배우고 프로젝트를 진행하며, 전반적인 개발에 대한 이해를 높힙니다.",
  },
  {
    number: 3,
    title: "런칭과 함께 집행해보는 마케팅",
    img: solution_3,
    desc: "프로덕트를 만들기만 하고 끝나지 않습니다. 시장에 내어놓고 반응을 얻어봅니다. 직접 고객의 피드백을 듣고 제품을 개선해봅니다.",
  },
  {
    number: 4,
    title: "데이터를 심고 직접 분석까지",
    img: solution_4,
    desc: "데이터 기반 의사결정을 가장 빠르게 배우는 방법은, 직접 데이터를 들여다 보는 것입니다. 내가 만든 서비스의 데이터를 통해 개선점을 발견합니다.",
  },
  {
    number: 5,
    title: "이 모든 경험을 묶어낸 포트폴리오",
    img: solution_5,
    desc: "프로덕트 생애주기 전반을 경험한 PM이 되어, 좋은 경험과 명확한 러닝포인트를 담은 이력서 및 포트폴리오를 작성합니다.",
  },
];

export const MktSolutionTitle = () => {
  return (
    <>
      마케팅 실무의 A to Z,
      <br />
      이렇게 경험합니다.
    </>
  );
};

export const mktLandingSolutionData = [
  {
    number: 1,
    title: "시장과 고객을 고려한 기획",
    img: mkt_solution_1,
    desc: "데이터에 기반하여 문제를 직접 정의하고, 비즈니스 임팩트와 고객친화적 관점을 모두 고려한 해결 방안을 모색합니다.",
  },
  {
    number: 2,
    title: "직접 개발한 서비스 배포",
    img: solution_2,
    desc: "노코드 툴을 활용해 마케팅할 프로덕트를 직접 제작해봅니다. 개발의 기초 지식을 다지고, 기획 단계부터 깊게 관여하여 제품의 이해도를 높입니다.",
  },
  {
    number: 3,
    title: "팀별 예산으로 마케팅 집행",
    img: solution_3,
    desc: "모의 프로젝트가 아닙니다. 팀별 예산을 투입해 SA, DA를 포함한 실제 마케팅을 집행합니다.",
  },
  {
    number: 4,
    title: "데이터 분석을 통한 지표 개선",
    img: solution_4,
    desc: "실전은 개선의 반복입니다. 마케팅 전략의 효율을 측정하고, 전략 수정 및 실행을 반복합니다.",
  },
  {
    number: 5,
    title: "이 모든 경험을 묶어낸 포트폴리오",
    img: solution_5,
    desc: "기획부터 지표 개선까지 모두 경험한 내용을 포트폴리오로 제작합니다. 이제 경험을 통해 자신있게 내 능력을 설득할 수 있습니다.",
  },
];
